import { render, staticRenderFns } from "./editdiv.vue?vue&type=template&id=de5d5248&scoped=true&"
import script from "./editdiv.vue?vue&type=script&lang=js&"
export * from "./editdiv.vue?vue&type=script&lang=js&"
import style0 from "./editdiv.vue?vue&type=style&index=0&id=de5d5248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5d5248",
  null
  
)

export default component.exports